import type React from 'react'
import type { IAvatarProps } from 'atoms/Avatar'
import type { IAvatarBlockProps } from '../AvatarBlock'

import { AvatarProfile } from 'atoms/Avatar/Templates'
import { AddProfileButton } from 'atoms/Button/Templates'
import { Icon, IconNames } from 'atoms/Icon'
import { TextAligning } from 'atoms/TextBox'
import {
  TextBoxMaxLine1FontXs,
  TextBoxMaxLine2FontSmBold,
} from 'atoms/TextBox/Templates'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { AvatarBlock } from '../AvatarBlock'
import { AvatarBlockAlignItems, AvatarBlockRowGaps } from '../AvatarBlock.h'
import {
  AddButtonWrapper,
  AvatarProfileBlockRootSC,
  AvatarProfileWrapper,
  InteractionLayoutSC,
  TextWrapperSC,
} from './AvatarProfileBlock.styled'

export type IAvatarProfileBlockProps = Omit<IAvatarBlockProps, 'children'> &
  IAvatarProps & {
    isAddButton?: boolean
    onClick?: (event: React.MouseEvent) => void
    selected?: boolean
    avatar?: string
    kidsProfile?: boolean
    subtitle?: string
    dimmed?: boolean
    groupHoverDim?: boolean
    locked?: boolean
  }

export const AvatarProfileBlock = ({
  title = '',
  alignItems = AvatarBlockAlignItems.Center,
  rowGap = AvatarBlockRowGaps.SIZE_20,
  isAddButton,
  interractive,
  onClick,
  selected,
  backgroundDefault,
  width = 116,
  avatar,
  kidsProfile,
  subtitle,
  dimmed,
  groupHoverDim,
  locked,
  ...rest
}: IAvatarProfileBlockProps) => (
  <AvatarProfileBlockRootSC
    data-avatar-profile-block='true'
    data-avatar-profile-block-group-hover={
      groupHoverDim ? 'enabled' : undefined
    }
    dimmed={dimmed}
  >
    <AvatarBlock
      alignItems={alignItems}
      rowGap={rowGap}
      width={width}
      interractive={interractive}
      disabled={locked}
      {...rest}
    >
      {!isAddButton && (
        <AvatarProfileWrapper onClick={onClick}>
          <AvatarProfile
            title={title}
            imageUrl={avatar}
            backgroundDefault={backgroundDefault}
            hasFallbackImage={!!avatar}
          />
          {(interractive || selected) && (
            <InteractionLayoutSC selected={selected}>
              <Icon name={IconNames.editPencil} />
              <Icon name={IconNames.selectedFavoriteIcon} />
            </InteractionLayoutSC>
          )}
        </AvatarProfileWrapper>
      )}

      {isAddButton && (
        <AddButtonWrapper>
          <AddProfileButton onClick={onClick} />

          {kidsProfile && <Icon name={IconNames.kidsProfile} />}
        </AddButtonWrapper>
      )}

      <TextWrapperSC>
        <TextBoxMaxLine2FontSmBold
          title={title}
          alignment={TextAligning.Center}
        />

        {subtitle && (
          <TextBoxMaxLine1FontXs
            title={subtitle}
            alignment={TextAligning.Center}
            color={Colors.TEXT_ICON_SECONDARY}
          />
        )}
      </TextWrapperSC>
    </AvatarBlock>
  </AvatarProfileBlockRootSC>
)
